(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/objects/context-menu-handler.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/objects/context-menu-handler.js');

'use strict';

svs.maltipset.objects.ContextMenuHandler = Marionette.MnObject.extend({
  contextMenuData: {
    onSpelguide: function(event) {
      if (event) {
        event.preventDefault();
      }
    },
    openSpelguide: function(startTab) {
      svs.components.Modal.show(
        svs.maltipset.views.Spelguide,
        { startTab: startTab },
        {
          title: 'Spelguide',
          headerClass: 'maltipset-modal-header',
          doubleWidth: !svs.core.detect.formfactor.mobile(),
          leftButton: {
            text: 'Stäng',
            visible: true,
            cssClass: 'btn-transparent-inverted'
          },
          rightButton: { visible: false }
        }
      );
    },
    showXperten: function() {
      svs.components.Modal.show(
        svs.maltipset.views.Xperten,
        { model: svs.maltipset.collections.coupons.getCurrentCoupon() },
        {
          title: 'PIX!',
          headerClass: 'maltipset-modal-header',
          leftButton: {
            text: 'Avbryt',
            visible: true,
            cssClass: 'btn-transparent-inverted'
          },
          rightButton: {
            text: 'Klar',
            visible: true,
            disabled: true,
            cssClass: 'btn-transparent-inverted',
            callback: function() {
              if (!this.changed) {
                return true;
              }

              var xpertObject = {
                xpertSize: this.systemSize,
                xpertSystem: this.useBaseRow ?
                  svs.maltipset.constants.XPERT_PROPERTIES.PARTIALQP :
                  svs.maltipset.constants.XPERT_PROPERTIES.WEIGHTEDQP
              };

              if (this.model.get('totalSelectedMatches') > 0) {
                var self = this;
                var dialog = new svs.components.dialog.Confirm({
                  branding: svs.components.dialog.branding.SPORT,
                  icon: 'help-2',
                  title: 'Dina tecken kommer att rensas',
                  message: [
                    {
                      type: svs.components.dialog.message.TEXT,
                      text: 'Vill du fortsätta ändå?'
                    }
                  ],
                  actions: [
                    {
                      title: 'Avbryt'
                    },
                    {
                      title: 'Fortsätt',
                      callback: function() {
                        dialog.close();
                        self.model.set(xpertObject);

                        if (self.useBaseRow) {
                          self.model.createBaseRow();
                        } else {
                          self.model.newXpert(false);
                        }
                      }
                    }
                  ]
                });
                svs.components.dialog.api.add(dialog);
              } else {
                this.model.set(xpertObject);

                if (this.useBaseRow) {
                  this.model.createBaseRow();
                } else {
                  this.model.newXpert(false);
                }
              }

              return true;
            }
          }
        }
      );
    },
    onClearAll: function() {
      var dialog = new svs.components.dialog.Confirm({
        branding: svs.components.dialog.branding.SPORT,
        icon: 'dustbin',
        title: 'Vill du rensa dina tecken?',
        actions: [
          {
            title: 'Avbryt'
          },
          {
            title: 'Fortsätt',
            callback: function() {
              dialog.close();
              svs.maltipset.collections.coupons.getCurrentCoupon().empty();
            }
          }
        ]
      });
      svs.components.dialog.api.add(dialog);
    },
    convertSystem: function(toSystem) {
      if (
        !svs.maltipset.collections.coupons
          .getCurrentCoupon()
          .canConvertToSystem(toSystem)
      ) {
        var dialog = new svs.components.dialog.Confirm({
          branding: svs.components.dialog.branding.SPORT,
          icon: 'help-2',
          title: 'Dina påbörjade rader kommer att rensas',
          message: [
            {
              type: svs.components.dialog.message.TEXT,
              text: 'Vill du fortsätta ändå?'
            }
          ],
          actions: [
            {
              title: 'Avbryt'
            },
            {
              title: 'Fortsätt',
              callback: function() {
                dialog.close();
                _.defer(function() {
                  svs.maltipset.collections.coupons
                    .getCurrentCoupon()
                    .changeSystem(toSystem);
                });
                svs.components.loader.show();
              }
            }
          ]
        });
        svs.components.dialog.api.add(dialog);
      } else {
        _.defer(function() {
          svs.maltipset.collections.coupons
            .getCurrentCoupon()
            .changeSystem(toSystem);
        });
        svs.components.loader.show();
      }
    },
    showSystemspel: function() {
      var self = this;
      svs.components.Modal.show(
        svs.maltipset.views.Systemspel,
        { model: svs.maltipset.collections.coupons.getCurrentCoupon() },
        {
          title: 'SYSTEMSPEL',
          headerClass: 'maltipset-modal-header',
          leftButton: {
            text: 'Avbryt',
            visible: true,
            cssClass: 'btn-transparent-inverted'
          },
          rightButton: {
            text: 'Klar',
            visible: true,
            cssClass: 'btn-transparent-inverted',
            callback: function() {
              if (this.changed) {
                self.convertSystem(this.selectedSystem);
              }
              return true;
            }
          }
        }
      );
    }
  },

  initContextMenu: function(options) {
    _.bindAll(this.contextMenuData, 'onSpelguide');
    this.isStartPage = options.isStartPage || false;
    this.hasDraws = _.isUndefined(options.hasDraws) ? true : options.hasDraws;
    var enableClearAll =
      options.enableClearAll &&
      svs.maltipset.collections.coupons.getCurrentCoupon().isEnabled() ||
      false;

    if (!_.isUndefined(svs.maltipset.data.spelguide)) {
      Backbone.history.navigate('/', { trigger: false });
      this.contextMenuData.openSpelguide(svs.maltipset.data.spelguide);
      delete svs.maltipset.data.spelguide;
    }

    if (this.isStartPage && svs.core.detect.formfactor.mobile()) {
      this.contextMenuData.menuType = 'button';
      this.contextMenuData.icon = 'icon-info';
      this.contextMenuData.surroundAnchor =
        svs.core.data.baseOriginalUrl + 'spelguide';
      this.contextMenuData.callback = this.contextMenuData.onSpelguide;
      this.contextMenuData.leftButtons = [];
      this.contextMenuData.rightButtons = [];
    } else if (this.hasDraws) {
      this.contextMenuData.menuType = 'menu';
      this.contextMenuData.leftButtonsInBlock = true;
      this.contextMenuData.icon = 'icon-nav-more-vertical';
      this.contextMenuData.leftButtons = [
        {
          text: 'PIX!',
          icon: 'icon-pix',
          cssClass: 'contextual-menu-swipe-button-maltipset',
          callback: this.contextMenuData.showXperten,
          disabled:
            svs.maltipset.collections.coupons &&
            !svs.maltipset.collections.coupons.getCurrentCoupon().isEnabled()
        },
        {
          text: 'Systemspel',
          icon: 'icon-systemspel',
          cssClass: 'contextual-menu-swipe-button-maltipset',
          callback: this.contextMenuData.showSystemspel,
          disabled:
            svs.maltipset.collections.coupons &&
            !svs.maltipset.collections.coupons.getCurrentCoupon().isEnabled()
        }
      ];

      this.contextMenuData.rightButtons = [
        {
          text: 'Rensa',
          block: true,
          icon: 'icon-dustbin',
          callback: this.contextMenuData.onClearAll,
          cssClass: 'contextual-menu-swipe-button-maltipset',
          disabled: !enableClearAll
        }
      ];
    }

    if (!svs.core.detect.formfactor.mobile()) {
      this.popover = undefined;
    }
    this.contextMenuData.useIconButtons = true;
    this.contextMenuData.contextScrollButtonClass =
      'contextual-menu-scroll-button-maltipset';
    this.contextMenuData.stickyMenuOffset = $('.js-product-base-tabs-nav').height();
    this.contextMenuData.useFixedMenu = false;
    this.contextMenuData.showMenuInHeader =
        options.showMenuInHeader || false;
    svs.components.contextualMenu.setMenuFunctionality(this.contextMenuData);
  },
  showDesktopHeader: function() {
    var config = {
      title: {
        row1: {
          brand: 'maltipset',
          alt: 'Måltipset'
        }
      },
      rightButtons: [],
      leftButtons: []
    };
    svs.core.template.updateConfig(config);
  }
});


 })(window);